import angular from 'angular';
import addressModalField from './addressModalField';
import './style.scss';

export default angular
  .module('components.addressModalField', [])
  .component('addressModalField', addressModalField).name;
